import DonutLargeOutlinedIcon from '@mui/icons-material/DonutLargeOutlined';
import {
  CheckCircle as CheckCircleIcon,
} from '@mui/icons-material'
import {
  Tooltip,
  CircularProgress
} from '@mui/material'
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';

export const downloadColumns = [
  {
    id: 'downloadId',
    label: 'Download id',
    width: '150px',
    align: 'left',

  },
  {
    id: 'reportName',
    label: 'Report name',
    width: '250px',
    align: 'left',
  },
  {
    id: 'lastModifiedDate',
    label: 'Loaded at',
    width: '180px',
  },
  {
    id: 'createdDate',
    label: 'Generated at',
    width: '180px',
  },
  {
    id: 'fileDownloadStatus',
    label: 'Status',
    width: '100px',
    align: 'center',
    render: value => {
      if (value === 'SUCCESS') {
        return (
          <Tooltip title="SUCCESS">
            <CheckCircleIcon
              sx={{
                color: '#4caf50',
                fontSize: '24px',
                cursor: 'pointer',
              }}
            />
          </Tooltip>
        )
      } else if (value === 'PENDING' || value === 'IN_PROGRESS') {
        return (
          <Tooltip title="In Progress">
            <CircularProgress
              size={20}
              disableShrink
              sx={{
                color: '#ff9800',
                cursor: 'pointer',
              }}
            />
          </Tooltip>
        )
      }
      else if (value === 'FAILED') {
        return (
          <Tooltip title="FAILED">
            <ErrorOutlineOutlinedIcon
              size={20}
              disableShrink
              sx={{
                color: '#ff9800',
                cursor: 'pointer',
              }}
            />
          </Tooltip>
        )
      }
      return value
    },
  },
  {
    id: 'createdBy',
    label: 'Downloaded by',
    width: '150px',
    align: 'left',
  },
]

export const downloadSearchFields = downloadColumns.map(col => ({
  ...col,
  type: 'text',
  placeholder: `Enter ${col.label}`,
}))



export const detailsColumn = [
  {
    id: "entityTans",
    label: "Entity TAN",
    width: "100px"
  },
  {
    id: "years",
    label: "Year",
    width: "150px",
    isFormatted: false
  },
  {
    id: "months",
    label: "Month",
    width: "150px"
  }
]